import * as React from 'react';
import * as H from 'history';
import { AdDataViewTypes } from '../../../types';
import {
  DATA_COLUMNS,
  DEFAULT_SORT,
  FILTER_DROPDOWNS,
  ORDERED_FILTER_KEYS,
  SEEN_KEYS,
  SORT_KEYS,
  VIEW_CHOICES,
} from './addata_constants';
import { dateNow, dateYesterday } from '../common/data_constants';
import {
  freeText,
  oneOfArray,
  Validator,
  validDate,
} from '../../filterValidators';
import ApiDataView from '../common/BaseDataView';
import { APIV2 } from '../../../constants';

export type Props = {
  history: H.History;
  type: AdDataViewTypes;
  route: string;
};

export type State = {
  validators: { [key: string]: Validator };
};

export type AdDataEntry = {
  readonly eps: Array<{ x: number; y: number }>;
  readonly code?: string;
  readonly event_codes: number;
  readonly users: number;
  readonly origin_users: number;
  readonly domains: number;
  readonly events: number;
  readonly name: string;
  readonly desc: string | undefined;
};

export default class AdDataView extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      validators: {
        start: validDate(dateYesterday),
        end: validDate(dateNow),
        event_code: freeText(),
        user: freeText(),
        origin_user: freeText(),
        domain: freeText(),
        sort: oneOfArray(SORT_KEYS),
      },
    };
  }

  render() {
    const { ...props } = this.props;

    return (
      <ApiDataView<AdDataEntry, AdDataViewTypes>
        title={'AD Event Data'}
        validators={this.state.validators}
        endpoint={APIV2.data.ad}
        {...props}
        viewChoices={VIEW_CHOICES}
        filterKeys={ORDERED_FILTER_KEYS}
        seenKeys={SEEN_KEYS}
        columns={DATA_COLUMNS}
        defaultSort={DEFAULT_SORT}
        filterDropdowns={FILTER_DROPDOWNS}
      />
    );
  }
}
